import * as actionTypes from 'actions';

const initialState = {
  modal: {
    isOpen: false,
    title: '',
    message: '',
    buttons: []
  },
  snackbar: {
    isOpen: false,
    message: '',
    variant: 'success',
  }
}

const interfaceReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SHOW_MODAL: {
      return {
        ...state,
        modal: { ...action.modal, isOpen: true, },
      }
    }
    case actionTypes.RESET_MODAL: {
      return {
        ...state,
        modal: { ...state.modal, isOpen: false },
      }
    }
    case actionTypes.SHOW_SNACKBAR: {
      return {
        ...state,
        snackbar: { ...action.snackbar, isOpen: true, },
      }
    }
    case actionTypes.RESET_SNACKBAR: {
      return {
        ...state,
        snackbar: { ...state.snackbar, isOpen: false },
      }
    }
    default: {
      return state;
    }
  }
}

export default interfaceReducer
